<template>
  <v-img v-if="atual"
    :src="this.atual.metadata.poster"
    contain
    :aspect-ratio="16 / 9"
    class="img"
  />
  <v-icon v-else size="50"> ri-shield-user-line </v-icon> 
</template>

<script>
import GET_ARCHIVES from "@/graphql/archives.gql";

import defaultImage from "@/assets/mini-logo.svg";

export default {
  name: "PatientPicture",
  props: {
    avatar: Object,
  },
  data() {
    return {
      archives: [],
      avatarPicture: null,
      currentFile: null,
    };
  },
  apollo: {
    archives: {
      query: GET_ARCHIVES,
      variables() {
        return {
          ownerType: "Patient::Avatar",
          ownerId: this.avatar.id,
        };
      },
    },
  },
  computed: {
    atual() {
      return this.lodash.first(this.pondFiles);
    },
    pondFiles() {
      return this.archives.map(function (archive) {
        let poster = defaultImage;
        if (archive.fileExtension.includes("image")) {
          poster = `${process.env.VUE_APP_BASE_URL}${archive.fileUrl}`;
        }
        return {
          source: archive.id,
          file_url: archive.fileUrl,
          file_name: archive.fileName,
          options: {
            type: "local",
            file: {
              name: archive.fileName,
              size: archive.fileSize,
              type: archive.fileExtension,
            },
            metadata: {
              poster: poster,
              fileUrl: `${process.env.VUE_APP_BASE_URL}${archive.fileUrl}`,
            },
          },
          metadata: {
            poster: poster,
          },
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
}
.border- {
  &normal {
    border: solid 4px var(--v-success-base);
  }
  &fitted {
    border: solid 4px var(--v-primary-base);
  }
}

.inner-border {
  border: 7px solid transparent;
}
</style>
